import { QUIZ_MILESTONES } from '../constants';
import { showPupBreedStep } from '../guard';

export const resolveQuizProgress = flags => {
  const steps = showPupBreedStep({ flags }, { payload: {} })
    ? QUIZ_MILESTONES
    : QUIZ_MILESTONES.filter(step => step !== 'pupBreed');

  return {
    totalSteps: steps.length,
    getStepNumber: step => {
      const index = steps.indexOf(step);
      return index === -1 ? null : index + 1;
    },
  };
};

export const resolveQuizProgressStep = (flags, step) => {
  const { totalSteps, getStepNumber } = resolveQuizProgress(flags);

  return {
    totalSteps,
    stepNumber: getStepNumber(step),
  };
};
